export const getLocal = (key) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  } catch {
    return null;
  }
};

export const setLocal = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    console.error(`[storage] Failed to set key: ${key}`);
  }
};

export const updateLocal = (key, updates) => {
  const current = getLocal(key) ?? {};
  setLocal(key, { ...current, ...updates });
};

export const removeLocal = (key) => {
  localStorage.removeItem(key);
};

export const clearLocal = () => {
  localStorage.clear();
};